export enum VariantType {
  CONTROL = "control",
  TEST = "test",
}

export enum ArticleAuthorType {
  CONTRIBUTOR_PROFILE = "contributorProfile",
  AUTHOR_PROFILE = "authorProfile",
}
